import { capitalize } from '@/filters'
import { computed } from '@vue/composition-api'
import { getStageLabel } from '@/services/startup-stages'
import { has } from 'lodash'
import moment from 'moment'
import { sectorLabel } from '@/services/sectors'

const NO_DATA_LABEL = 'No data'

export default function useStats({
  DEBUG,
  applications,
  dateAttr,
  datesRange,
}) {
  const summaryChartSeries = computed(() => {
    const map = {}
    applications.value.forEach((app) => {
      const date = moment(app[dateAttr.value]).format('Y-MM-DD')
      if (!map[date]) {
        map[date] = []
      }
      map[date].push(app)
    })
    return [
      {
        name: 'Submissions',
        data: datesRange.value.map((date) => {
          return [new Date(date).getTime(), (map[date] || []).length]
        }),
      },
    ]
  })

  const getStatsData = ({ getter, keyToLabel }) => {
    const map = {}
    applications.value.forEach((a) => {
      const items = getter(a)
      console.log(' => getStatsData | items:', items)
      items.forEach((key) => {
        if (!has(map, key)) {
          map[key] = 0
        }
        map[key] += 1
      })
    })
    return Object.keys(map).map((key) => {
      return {
        name: keyToLabel(key),
        value: map[key],
      }
    })
  }

  const countriesData = computed(() => {
    return getStatsData({
      getter: (a) => arrayOrNoData([a.startup_country]),
      keyToLabel: (key) => key,
    })
  })

  const sectorsData = computed(() => {
    return getStatsData({
      getter: (a) => arrayOrNoData(a.startup_sectors),
      keyToLabel: (key) => sectorLabel(key),
    })
  })

  const productTypesData = computed(() => {
    return getStatsData({
      getter: (a) => arrayOrNoData(a.startup_product_types),
      keyToLabel: (key) => capitalize(key),
    })
  })

  const companyStagesData = computed(() => {
    return getStatsData({
      getter: (a) => arrayOrNoData([a.startup_stage]),
      keyToLabel: getStageLabel,
    })
  })

  const companyTypesData = computed(() => {
    return getStatsData({
      getter: (a) => arrayOrNoData(a.startup_business_types),
      keyToLabel: (key) => key,
    })
  })

  return {
    summaryChartSeries,
    countriesData,
    sectorsData,
    productTypesData,
    companyStagesData,
    companyTypesData,
  }
}

function arrayOrNoData(array) {
  if (!array) {
    return [NO_DATA_LABEL]
  }
  if (array.length === 0) {
    return [NO_DATA_LABEL]
  }
  if (array.length === 1 && !array[0]) {
    return [NO_DATA_LABEL]
  }
  return array
}
